import React, {useMemo} from 'react';
import {useTranslation} from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TextField from "@material-ui/core/TextField";
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import {Typography} from "@material-ui/core";
import {connect} from "react-redux";
import {ADD_NOTIFICATION} from "../store/action";
import Box from "@material-ui/core/Box";


const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        padding: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    adornment: {
        pointerEvents: 'none'
    }

}));

const CopyLinkToClipboard = ({shortHash, dispatch}) => {
    const classes = useStyles();
    const {t} = useTranslation()
    const linkToBook = useMemo(() => {
        const arr = window.location.href.split('/')
        return `${arr[0]}//${arr[2]}/s/${shortHash}`
    }, [shortHash])

    return <div className={classes.root}>
        <Typography gutterBottom>{t('Link_to_book')}</Typography>
        <TextField color={'primary'} variant={'outlined'} fullWidth
                   InputProps={{
                       readOnly: true,
                       dir: 'ltr',
                       endAdornment: <Box p={1} className={classes.adornment}><FileCopyOutlinedIcon
                           color={'primary'}/></Box>,
                   }}
                   value={linkToBook}
                   onFocus={(el) => {
                       try {
                           el.target.select()
                           const ok = document.execCommand('copy');

                           if (ok) {
                               dispatch({
                                   type: ADD_NOTIFICATION,
                                   payload: {
                                       type: 'success',
                                       text: t('link_copied_to_clipboard')
                                   }
                               })
                           }
                       } catch (err) {
                       }
                   }}/>
    </div>
}

export default connect()(CopyLinkToClipboard);